import { SelectOption } from '@/components/form-builder/form-builder.types';
import { ApprovalTypeDto } from '@/types';
import { createStore, withProps } from '@ngneat/elf';

export interface ApprovalTypeStateProps {
  response: any;
  dto: ApprovalTypeDto;
  approvalTypeSelected: SelectOption;
  isEqual: boolean;
  serverState: any;
}

export const approvalTypeInitialState: ApprovalTypeStateProps = {
  response: [],
  dto: {
    libelle: '',
    organismeDeDeliveranceAgrementsId: 0,
  },
  approvalTypeSelected: {
    name: '',
    code: '',
  },
  isEqual: true,
  serverState: undefined,
};

export const approvalTypeStateStore = createStore(
  { name: 'approvalType-state' },
  withProps<ApprovalTypeStateProps>({
    ...approvalTypeInitialState,
  })
);
